export default __webpack_public_path__ + "static/media/user.3a5400b0.svg";